import React from 'react';
import classNames from 'classnames';
import SlabLogo from '../components/SlabLogo';
import * as styles from './AccountContentContainer.module.scss';

interface AccountContentContainerProps {
  children?: React.ReactNode;
  subtitle?: string;
  title?: string;
}

const AccountContentContainer = ({
  children,
  subtitle,
  title,
}: AccountContentContainerProps) => (
  <div id="content" className={styles.container}>
    <div className={classNames(styles.main, 'auth-form')}>
      <SlabLogo className={styles.logo} />
      {title && (
        <header className={styles.header}>
          <h2>{title}</h2>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </header>
      )}
      {children}
    </div>
  </div>
);

export default AccountContentContainer;
